var render, staticRenderFns
import script from "./EditLabelMixin.vue?vue&type=script&lang=js"
export * from "./EditLabelMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f086002",
  null
  
)

export default component.exports